import React from 'react';
import { useTranslation } from 'react-i18next';

const RoomNumberSelect = ({ roomNumber, onChange }) => {
  const { t } = useTranslation();

  return (
    <div>
      <p className="font-primaryMedium text-primary text-base">{t('products.roomNumber')}</p>
      <p className="font-primaryRegular text-sm text-primaryOrange mb-1">
        {t('products.requiredTag')}
      </p>
      <div className="flex flex-row flex-wrap">
        <input
          id="room-number"
          name="room-number"
          value={roomNumber}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          placeholder={t('products.roomNumberPlaceholder')}
          className="font-primaryMedium text-base text-bland outline-none w-full resize-none min-h-[3rem]"
        />
      </div>
    </div>
  );
};

export default RoomNumberSelect;
